<template>
  <div class="top-bar">
    <ProgressView v-if="isRequestInProgress" />
    <!-- Title Area -->
    <div class="title-area">
      <div class="contents">
        <i
          v-if="getMode === 'EDIT' || getMode === 'VIEW'"
          class="material-icons back-icon"
          @click="$router.push('/consoles')"
          >keyboard_arrow_left</i
        >
        <a v-else class="brand-link" href="https://locale.ai">
          <img src="@/assets/locale-logo.svg" class="brand-logo" />
        </a>
        <div class="flex-col mar-left-10">
          <h1 class="title">NYC Subway Risk Analysis</h1>
          <p class="description">Locale.ai</p>
        </div>
      </div>
    </div>

    <!-- Content area -->
    <div class="search-area" @click="$emit('toggleSearch')">
      <icon size="20">map</icon>
      <p class="city-text flex-expand">
        {{ getActiveCity ? getActiveCity.name : "Choose City" }}
      </p>
      <i class="material-icons search-icon">search</i>
    </div>
    <div class="icons-area">
      <button
        :class="['toggle-button', { active: !showTable }]"
        @click="$emit('showMap')"
      >
        <icon size="18" @click="$emit('showMap')">map</icon>
        Map View
      </button>
      <button
        :class="['toggle-button', { active: showTable }]"
        @click="$emit('showTable')"
      >
        <icon size="18" @click="$emit('showTable')">table_chart</icon>
        Table View
      </button>
    </div>
    <!-- icons area -->
    <SlideXLeftTransition>
      <div v-if="!showTable" class="icons-area">
        <div
          :class="['selection-icon', { active: !isMeasureModeEnabled }]"
          @click="toggleMeasureMode(false)"
        >
          <i class="material-icons">touch_app</i>
          <div class="tooltip popup-shadow">
            <h4 class="tooltip-header">Selection mode</h4>
            <p class="tooltip-description">
              Helps you select items and move around the map
            </p>
          </div>
        </div>
        <div
          :class="['selection-icon', { active: isMeasureModeEnabled }]"
          @click="toggleMeasureMode(true)"
        >
          <i class="material-icons">square_foot</i>
          <div class="tooltip popup-shadow">
            <h4 class="tooltip-header">Measure Distance mode</h4>
            <p class="tooltip-description">
              Helps you measure distance between points
            </p>
          </div>
        </div>
      </div>
    </SlideXLeftTransition>
    <expand />
    <div class="button-area">
      <button
        class="toggle-button mar-right-15"
        v-if="getMode === 'EDIT' || getMode === 'VIEW'"
        @click="$emit('clickShare')"
      >
        <icon size="18" @click="$emit('clickShare')">share</icon>Share
      </button>
      <Button
        v-if="getMode === 'EDIT'"
        type="primary"
        icon="save"
        text="Save Console"
        @click="saveConsole"
      />
      <Button
        v-else-if="getMode === 'VIEW'"
        type="primary"
        icon="edit"
        text="Edit Console"
        @click="openEditMode"
      />
    </div>
  </div>

  <!-- title section -->
  <!-- <div class="analysis-title">
      <icon>bar_chart</icon>
      <div class="texts">
        <h3>Supply Demand Gap</h3>
      </div>
    </div> -->

  <!-- <CityFilter
      @click="$emit('toggleSearch')"
      placeholder="Select City"
      v-model="selectedCity"
      class="cityFilterOverride"
    /> -->
  <!-- Tools area -->
  <!-- <div class="tools-area">
      <div class="context-switch">
        <button
          :class="['toggle-button', { active: !showTable }]"
          @click="$emit('showMap')"
        >
          <icon size="18" @click="$emit('showMap')">map</icon>
          Map View
        </button>
        <button
          :class="['toggle-button', { active: showTable }]"
          @click="$emit('showTable')"
        >
          <icon size="18" @click="$emit('showTable')">table_chart</icon>
          Table View
        </button>
      </div>
    </div> -->

  <!-- <Chits
      :chits="getFilterChits"
      @clearFilter="(filter) => handleFilterChange({ filter })"
    /> -->

  <!-- <expand /> -->
  <!-- <button class="toggle-button mar-right-5" v-if="getMode === 'EDIT'">
      <icon size="18">settings</icon>Settings
    </button>
    <button
      class="toggle-button mar-right-15"
      v-if="getMode === 'EDIT' || getMode === 'VIEW'"
      @click="$emit('clickShare')"
    >
      <icon size="18" @click="$emit('clickShare')">share</icon>Share
    </button>
    <Button
      v-if="getMode === 'EDIT'"
      type="primary"
      icon="save"
      text="Save Console"
      @click="saveConsole"
    />
    <Button
      v-else-if="getMode === 'VIEW'"
      type="primary"
      icon="edit"
      text="Edit Console"
      @click="openEditMode"
    /> -->
</template>

<script>
import ToolsList from "@/components/static_entity_analysis/views/ToolsList";
import Button from "@/components/global/views/Button";
import CityFilter from "@/components/entities/views/CityFilter";
import Chits from "@/components/static_entity_analysis/views/chits";
import { mapGetters, mapActions } from "vuex";
import { trackConsoleSave } from "@/lib/analytics";
import { SlideXLeftTransition } from "vue2-transitions";

export default {
  props: {
    showTable: Boolean,
  },
  components: {
    ToolsList,
    Button,
    CityFilter,
    Chits,
    SlideXLeftTransition,
  },
  data() {
    return {
      selectedCity: null,
      isRequestInProgress: false,
    };
  },
  computed: {
    ...mapGetters("Location", [
      "getCities",
      "getFetchingCities",
      "getActiveCity",
    ]),
    ...mapGetters("StaticEntity", [
      "getMode",
      "getCurrentStaticEntity",
      "getAppliedFilters",
      "isMeasureModeEnabled",
    ]),
    ...mapGetters("Entities", ["getStaticEntitiesById"]),
    getStaticEntityName() {
      if (this.getStaticEntitiesById && this.getCurrentStaticEntity)
        return this.getStaticEntitiesById[this.getCurrentStaticEntity].name;
      else return "Static Entities";
    },
    getFilterChits() {
      return Object.keys(this.getAppliedFilters).reduce(
        (result, filter_key) => {
          if (
            this.getAppliedFilters[filter_key] &&
            this.getAppliedFilters[filter_key].length > 0
          ) {
            const filter_name = filter_key.split("__")[1];
            const filters = this.getAppliedFilters[filter_key].map((item) => {
              return {
                id: item,
                name: item,
                value: item,
                column: filter_key,
                col_name: filter_name,
              };
            });
            result.push(...filters);
          }
          return result;
        },
        []
      );
    },
  },
  methods: {
    // ...mapActions("StaticEntity", ["setActiveCity"]),
    ...mapActions("StaticEntity", [
      "refetchAllData",
      "createPayloadForSaving",
      "reset",
      "initializeConsole",
      "setMode",
      "toggleEntityFilter",
      "toggleMeasureMode",
    ]),
    ...mapActions("Location", ["setActiveCity"]),
    ...mapActions("DataManager", ["createConsole", "updateConsole"]),
    ...mapActions("Comments", ["setCommentMode", "postAllComments"]),
    async saveConsole() {
      this.isRequestInProgress = true;
      const payload = await this.createPayloadForSaving();
      // console.log(payload);
      const queries = this.$route.query;

      if (queries.id) {
        this.updateConsole({ payload, dashboard_id: queries.id }).then(() => {
          // this.reset();
          // trackConsoleSave();
          this.isRequestInProgress = false;
          this.setMode("VIEW");
          this.setCommentMode("VIEW");
        });
      } else {
        this.createConsole(payload).then(({ dashboard_id }) => {
          // this.reset();
          // trackConsoleSave();
          this.postAllComments({ dashboard_id });
          this.isRequestInProgress = false;
          this.setMode("VIEW");
          this.setCommentMode("VIEW");
        });
      }
    },
    openEditMode() {
      // const queries = this.$route.query;
      // this.$router.push(`/analysis/edit?id=${queries.id}`);
      this.setMode("EDIT");
      this.setCommentMode("EDIT");
    },
    handleFilterChange({ filter, heading }) {
      this.toggleEntityFilter({ column: filter.column, value: filter.value });
    },
  },
  watch: {
    selectedCity(city) {
      this.setActiveCity(city);
      // this.refetchAllData();
    },
    getActiveCity: {
      immediate: true,
      handler(city) {
        if (this.selectedCity !== city) this.selectedCity = city;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 100%;
  height: 100%;
  max-height: 60px;
  background: var(--color-secondary);
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 999;
  border-bottom: 1px solid var(--border-color);

  .title-area {
    width: 349px;
    max-width: 349px;
    height: 100%;
    border-right: 1px solid var(--border-color);

    .contents {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 10px;
      height: 100%;

      .brand-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .brand-logo {
        width: 25px;
        height: 25px;
        padding: 7px;
        background: var(--color-secondary-light);
        border-radius: 5px;
        margin: 0 5px;

        &:hover {
          opacity: 0.9;
        }
      }

      .back-icon {
        padding: 5px;
        background: var(--color-secondary-light);
        border-radius: 5px;
        margin: 0 5px;
        transition: 0.3s all ease-in-out;

        &:hover {
          cursor: pointer;
          color: var(--color-primary);
          background: var(--color-primary-light);
        }

        &:active {
          transform: scale(0.95);
        }
      }

      .title {
        font-size: 1rem;
      }

      .description {
        margin: 0;
        font-size: 0.8rem;
        opacity: 0.7;
      }
    }
  }

  .search-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0px 8px 10px;
    margin: 0 5px;
    background: var(--color-secondary-light);
    border-radius: 5px;
    width: 300px;
    transition: 0.3s all ease-in-out;

    .city-text {
      margin: 0;
      padding: 0 10px;
    }

    .search-icon {
      color: var(--color-primary);
      margin: 0 10px;
    }

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }

    &:active {
      transform: scale(0.97);
    }
  }

  .icons-area {
    border-left: 1px solid var(--border-color);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;

    .toggle-button {
      display: flex;
      flex-direction: row;
      align-items: center;
      outline: none;

      &:first-child {
        margin-right: 5px;
      }
    }

    .selection-icon {
      margin-left: 7px;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      i {
        padding: 7px;
        border-radius: 3px;
        transition: 0.3s all ease-in-out;
        opacity: 0.7;

        &:hover {
          opacity: 1;
          cursor: pointer;
          color: var(--color-primary);
          background: var(--border-color);
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .tooltip {
        position: absolute;
        top: 50px;
        left: 0;
        white-space: nowrap;
        padding: 10px;
        background: var(--color-secondary);
        color: var(--font-color);
        border-radius: 5px;
        display: none;
        flex-direction: column;

        .tooltip-description {
          margin: 0;
          opacity: 0.7;
        }
      }

      &:hover {
        .tooltip {
          display: flex;
        }
      }

      &.active {
        i {
          opacity: 1;
          color: var(--color-primary);
          background: var(--color-primary-light);
        }
      }
    }

    .dropdown-icon {
      margin-left: 7px;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      .icon-holder {
        padding: 5px;
        border-radius: 3px;
        transition: 0.3s all ease-in-out;

        &:hover {
          cursor: pointer;
          color: var(--color-primary);
          background: var(--border-color);

          + .tooltip {
            display: flex;
          }
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .tooltip {
        position: absolute;
        top: 50px;
        left: 0;
        white-space: nowrap;
        padding: 10px;
        background: var(--color-secondary);
        color: var(--font-color);
        border-radius: 5px;
        display: none;
        flex-direction: column;

        .tooltip-description {
          margin: 0;
          opacity: 0.7;
        }
      }

      .drop-down-options {
        position: absolute;
        top: 50px;
        border-radius: 5px;
        background: var(--color-secondary);
        width: 250px;

        .option {
          padding: 15px;
          border-bottom: 1px solid var(--border-color);

          .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }

      // &:hover {
      //   .tooltip {
      //     display: flex;
      //   }
      // }
    }
  }

  .button-area {
    display: flex;
    margin-right: 10px;
  }
}
</style>
